import { commonEnvironments } from './environment.common';

export const environment = {
  production: false,
  baseUrls: commonEnvironments.devBaseUrls,
  ...commonEnvironments,
};
